module.exports = __webpack_public_path__ + "genesee_village.4928c637d10ff51240dbfe6618b49e09.png";